import React, { useState, useEffect } from 'react'
import { Button, message } from 'antd'

import { connect } from 'react-redux'
import pollBG from "../../assets/learningCardIcons/Behavior poll BG.svg"
import pollQuestionBg from "../../assets/learningCardIcons/Behavior poll options BG.svg"
import pollOptionBg from "../../assets/learningCardIcons/Option BG.svg"
import "./feeback.css"
import { savePoll, getPollQuestions, setStep } from '../../reduxStore/actions/action'
import { CaretLeftOutlined } from '@ant-design/icons'
import CongratulationsModal from './congratulationsModal'



function Poll({ getPollQuestions, savePoll, setStep, pollQuestions, gameAssets, utilAssets, isSkipped }) {



    const [formData, setFormData] = useState([]);
    const [isCongoModalOpen, setIsCongoModalOpen] = useState(false)

    useEffect(() => {
        getPollQuestions((pollQuestions) => {
            let arr = pollQuestions?.map(ele => {
                let obj = {};
                obj["questionId"] = ele.id;
                obj["optionId"] = null
                return obj;
            })
            setFormData([...arr])
        }, () => {

        })
    }, [])


    // Handle form submission (optional)
    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Form Data:', formData);
        let allSelected = true;
        formData?.forEach(f => {
            if (f.optionId == null) {
                message.error('Please choose all the questions!');
                allSelected = false;
                return
            }

        });

        if (allSelected) {
            savePoll({ response: formData }, () => {
                setIsCongoModalOpen(true)
            }, () => {

            })
        }
    };

    // const PollsDesign = ({ pollsData, index1 }) => {

    //     return (
    //         <div className="poll-container" >
    //             <div className="poll-question-bg">
    //                 <img className="full-img" src={pollQuestionBg} alt="Poll Question Background" />

    //                 <div className="poll-parent ">
    //                     <div className="poll-options scroll-bar-universal" style={{}}>
    //                         <div className="poll-question-text">
    //                             {pollsData?.question}
    //                         </div>
    //                         {pollsData?.options?.map((item, index) => (
    //                             <div
    //                                 key={index}
    //                                 className="poll-option"
    //                                 style={{
    //                                     boxShadow: formData?.[index1]?.["option"] === item ? "0 0 5px 5px green" : "none",
    //                                     // transform: formData?.[index1]?.["option"] === item ? "scale(1.1)" : "scale(1)",
    //                                     transition: "transform 0.3s, box-shadow 0.3s",
    //                                 }}
    //                                 onClick={() => {
    //                                     if (formData && formData.length > 0) {
    //                                         formData[index1]["option"] = item;
    //                                         setFormData([...formData]);
    //                                     }
    //                                 }}
    //                             >
    //                                 <img className="full-img" src={pollOptionBg} alt="Poll Option Background" />
    //                                 <div className="poll-option-text">
    //                                     {item}
    //                                 </div>
    //                             </div>
    //                         ))}

    //                     </div>
    //                 </div>

    //             </div>
    //         </div>
    //     );
    // }
    const isDisabled = formData.some(item => item.optionId === null);
    console.log("formData", formData)
    return (
        <div className="super-parent-poll">
            {isSkipped ?
                <div style={{ position: "absolute", zIndex: 10, top: "7%", left: "5%" }}><CaretLeftOutlined onClick={() => setStep(4)} style={{ fontSize: 45, color: "#44301E" }} /></div>
                : null}
            <div className='r-c-c header-text' > How did you enjoy the SeTU experience? </div>
            <>
                <div className='r-c-c m-t-20' style={{ position: "relative", width: "95%", height: "100%", alignItems: "flex-start" }}>

                    <div className='r-c-c-c parent-poll-bg' style={{}}>
                        <img className='full-img' src={utilAssets?.pollBg} alt="Learning Background" />

                        <div className="grid-container-poll " style={{}}>
                            {pollQuestions?.map((item, index1) => (
                                <div key={index1} className="grid-item-feed">
                                    <div className="poll-container" >
                                        <div className="poll-question-bg">
                                            <img className="full-img" src={utilAssets?.pollQuestionBg} alt="Poll Question Background" />

                                            <div className="poll-parent ">
                                                <div className="poll-options" style={{}}>
                                                    <div className="poll-question-text">
                                                        {item?.question}
                                                    </div>
                                                    {item?.options?.map((item, index) => (
                                                        <div
                                                            key={item.id}
                                                            id={'poll-options' + Math.random()}
                                                            className="poll-option"
                                                            style={{
                                                                borderRadius: 10,
                                                                boxShadow: formData?.[index1]?.["optionId"] === item.id ? "0 0 8px 2px #52FF00" : "none",
                                                                // transform: formData?.[index1]?.["option"] === item ? "scale(1.1)" : "scale(1)",
                                                                transition: "transform 0.3s, box-shadow 0.3s",
                                                            }}
                                                            onClick={() => {
                                                                if (formData && formData.length > 0) {
                                                                    formData[index1]["optionId"] = item.id;
                                                                    setFormData([...formData]);
                                                                }
                                                            }}
                                                        >
                                                            <img className="full-img" src={utilAssets?.pollOptionBg} alt="Poll Option Background" />
                                                            <div className="poll-option-text">
                                                                {item.option}
                                                            </div>
                                                        </div>
                                                    ))}

                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="r-c-c m-t-15 done-btn-learning" style={{}}><Button disabled={isDisabled} style={{ minWidth: "8vw", minHeight: "5vh", borderRadius: 30 }} onClick={handleSubmit}>NEXT</Button></div>
            </>
            {isCongoModalOpen && <CongratulationsModal
                setStep={setStep}
                isCongoModalOpen={isCongoModalOpen}
                setIsCongoModalOpen={setIsCongoModalOpen}
                congoText={utilAssets?.congratulationText}
            />}
        </div>
    )
}

const mapStateToProps = state => {

    const { pollQuestions, gameAssets, utilAssets } = state?.SeTu;
    return { pollQuestions, gameAssets, utilAssets }
}


const mapDispatchToProps = dispatch => ({
    getPollQuestions: (successCallBack, callBack) => dispatch(getPollQuestions(successCallBack, callBack)),
    savePoll: (params, successCallBack, callBack) => dispatch(savePoll(params, successCallBack, callBack)),
    setStep: (val) => dispatch(setStep(val)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Poll)
